// src/pages/Private/Teacher/AssignmentManagement/CreateAssignment.jsx
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { createAssignment, getLessonById } from '../../../../api/teacherApi';
import './CreateAssignment.css';

function CreateAssignment() {
  const { lessonId } = useParams();
  const navigate = useNavigate();
  const [lesson, setLesson] = useState(null);
  const [loading, setLoading] = useState(true);
  const [assignment, setAssignment] = useState({
    title: '',
    description: '',
    dueDate: '',
    totalPoints: 100,
    attachments: []
  });
  const [newAttachment, setNewAttachment] = useState({ title: '', url: '' });

  useEffect(() => {
    loadLesson();
  }, [lessonId]);

  const loadLesson = async () => {
    try {
      const data = await getLessonById(lessonId);
      setLesson(data);
    } catch (error) {
      console.error('Ders yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setAssignment({
      ...assignment,
      [e.target.name]: e.target.value
    });
  };

  const addAttachment = () => {
    if (newAttachment.title && newAttachment.url) {
      setAssignment({
        ...assignment,
        attachments: [...assignment.attachments, { ...newAttachment, type: 'link' }]
      });
      setNewAttachment({ title: '', url: '' });
    } else {
      alert('Lütfen kaynak başlığı ve URL girin');
    }
  };

  const removeAttachment = (index) => {
    setAssignment({
      ...assignment,
      attachments: assignment.attachments.filter((_, i) => i !== index)
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createAssignment(lessonId, assignment);
      navigate(`/teacher/lesson/${lessonId}`);
    } catch (error) {
      console.error('Ödev oluşturulurken hata:', error);
    }
  };

  const getMinDate = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  };

  if (loading) return <div className="loading">Yükleniyor...</div>;

  return (
    <div className="create-assignment">
      <div className="page-header">
        <h1>Ödev Oluştur</h1>
        <p>Ders: {lesson?.title}</p>
      </div>

      <form onSubmit={handleSubmit} className="assignment-form">
        <div className="form-group">
          <label>Ödev Başlığı *</label>
          <input
            type="text"
            name="title"
            value={assignment.title}
            onChange={handleChange}
            required
            placeholder="Örn: React Proje Ödevi"
          />
        </div>

        <div className="form-group">
          <label>Açıklama *</label>
          <textarea
            name="description"
            value={assignment.description}
            onChange={handleChange}
            required
            rows="6"
            placeholder="Ödev detaylarını, isterleri ve teslim kurallarını yazın..."
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Teslim Tarihi *</label>
            <input
              type="datetime-local"
              name="dueDate"
              value={assignment.dueDate}
              onChange={handleChange}
              required
              min={getMinDate()}
            />
          </div>

          <div className="form-group">
            <label>Toplam Puan</label>
            <input
              type="number"
              name="totalPoints"
              value={assignment.totalPoints}
              onChange={handleChange}
              min="1"
              max="1000"
            />
          </div>
        </div>

        <div className="form-section">
          <h3>Ek Kaynaklar (İsteğe Bağlı)</h3>
          <div className="attachment-input-group">
            <input
              type="text"
              placeholder="Kaynak başlığı"
              value={newAttachment.title}
              onChange={(e) => setNewAttachment({...newAttachment, title: e.target.value})}
            />
            <input
              type="url"
              placeholder="Kaynak URL"
              value={newAttachment.url}
              onChange={(e) => setNewAttachment({...newAttachment, url: e.target.value})}
            />
            <button type="button" onClick={addAttachment} className="btn-add">
              +
            </button>
          </div>

          {assignment.attachments.length > 0 && (
            <div className="attachments-list">
              <h4>Eklenen Kaynaklar:</h4>
              {assignment.attachments.map((att, index) => (
                <div key={index} className="attachment-item">
                  <a href={att.url} target="_blank" rel="noopener noreferrer">
                    {att.title}
                  </a>
                  <button type="button" onClick={() => removeAttachment(index)} className="remove-attachment">
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary">
            Ödev Oluştur
          </button>
          <button type="button" className="btn-cancel" onClick={() => navigate(-1)}>
            İptal
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateAssignment;